import { History, CalendarClock, Archive } from 'lucide-react';
import { StatTile } from '../../design/StatTile';
import { formatAgo, formatNextRun } from '../../../utils/overview-format';
import { kindLabel, formatMb } from '../../../utils/backup-format';
import type { TimelineItem } from './types';

interface Props {
  last: TimelineItem | null;
  nextMs: number | null;
  online: boolean;
  hddCount: number;
  hddMb: number;
  cloudCount: number;
  cloudMb: number;
}

/** Die drei Fragen, die man beim Öffnen hat: Wann zuletzt? Wann als Nächstes? Wie viel liegt da? */
export const BackupStatusStrip = ({ last, nextMs, online, hddCount, hddMb, cloudCount, cloudMb }: Props) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <StatTile
      label="Letztes Backup"
      icon={<History size={14} />}
      value={last ? formatAgo(last.ms) : '—'}
      sub={last ? `${kindLabel(last.type)} · ${last.isLocal ? 'HDD' : 'Cloud'}` : 'Noch keine Sicherung vorhanden'}
      accent={last ? 'online' : 'warn'}
    />
    <StatTile
      label="Nächstes Backup"
      icon={<CalendarClock size={14} />}
      value={nextMs ? formatNextRun(nextMs) : 'nicht geplant'}
      sub={nextMs ? (online ? 'läuft automatisch' : 'nur wenn der Server läuft') : 'Zeitplan unten einschalten'}
      accent={nextMs ? 'ember' : 'muted'}
    />
    <StatTile
      label="Gespeichert"
      icon={<Archive size={14} />}
      value={`${hddCount + cloudCount}`}
      sub={`HDD ${hddCount} (${formatMb(hddMb)}) · Cloud ${cloudCount} (${formatMb(cloudMb)})`}
      accent="muted"
    />
  </div>
);
